import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo/gitee.png';
import _imports_1 from '@/assets/logo/wechatLogo.png';
const _withScopeId = n => (_pushScopeId("data-v-609afd12"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-bar"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "images-logo",
  src: "http://ocr.nbdj.cc/test/xiaoniu-logo.png"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "牛站")], -1));
const _hoisted_2 = {
  class: "avatar-wrapper"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "username-text"
};
const _hoisted_5 = {
  style: {
    "color": "white"
  }
};
const _hoisted_6 = {
  class: "login-container"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login-header"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "login-logo",
  src: "http://ocr.nbdj.cc/test/xiaoniu-logo.png"
}), /*#__PURE__*/_createElementVNode("h2", null, "欢迎登录")], -1));
const _hoisted_8 = {
  class: "login-type-switch"
};
const _hoisted_9 = {
  class: "remember-forgot"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login-divider"
}, [/*#__PURE__*/_createElementVNode("span", null, "其他登录方式")], -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Gitee"
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Gitee", -1));
const _hoisted_13 = [_hoisted_11, _hoisted_12];
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "微信"
}, null, -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "微信", -1));
const _hoisted_16 = [_hoisted_14, _hoisted_15];
const _hoisted_17 = {
  class: "login-container"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login-header"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "login-logo",
  src: "http://ocr.nbdj.cc/test/xiaoniu-logo.png"
}), /*#__PURE__*/_createElementVNode("h2", null, "欢迎注册")], -1));
const _hoisted_19 = {
  class: "captcha-container"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "captcha-mask"
}, "点击刷新", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login-divider"
}, [/*#__PURE__*/_createElementVNode("span", null, "已有账号?")], -1));
const _hoisted_23 = {
  class: "login-container"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login-header"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "login-logo",
  src: "http://ocr.nbdj.cc/test/xiaoniu-logo.png"
}), /*#__PURE__*/_createElementVNode("h2", null, "找回密码")], -1));
const _hoisted_25 = {
  class: "email-code-container"
};
const _hoisted_26 = {
  key: 1,
  class: "countdown-container"
};
const _hoisted_27 = {
  class: "countdown-number"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "countdown-text"
}, "秒后重试", -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login-divider"
}, [/*#__PURE__*/_createElementVNode("span", null, "想起密码了?")], -1));
import { routes } from "@/router/routes";
import { useRouter } from "vue-router";
import { computed, h, nextTick, onMounted, ref, onUnmounted } from "vue";
import checkAccess from "@/access/checkAccess";
import { ArrowDown } from '@element-plus/icons-vue';
import { useStore } from "vuex";
import '@/styles/GlobalHeader.scss';
import { useLoginUserStore } from "@/store/loginUser";
import { UserOutlined, LockOutlined, SafetyCertificateOutlined, MailOutlined, CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { CaptchaControllerService, GiteeLoginConrollerService, SysRegisterControllerService } from "../../../generated";
import { XiaoniuFrontedControllerService } from "../../../generated/services/XiaoniuFrontedControllerService";
export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  setup(__props) {
    const store = useStore();
    const userLoaded = ref(false);
    const router = useRouter();
    const loginUserStore = useLoginUserStore();
    const menuItemRef = ref(null);
    const truncatedUserName = computed(() => {
      const nickname = loginUserStore.loginUser?.nickName ?? '';
      const maxLength = 5; // 设置最大显示长度
      if (nickname.length > maxLength) {
        return nickname.slice(0, maxLength) + '...';
      }
      return nickname;
    });
    const isLogin = computed(() => {
      if (loginUserStore.loginUser.userName === '') {
        return false;
      }
      return true;
    });
    const handleCommand = command => {
      if (command === "logout") {
        store.commit('updateUser', {});
        loginUserStore.removeLoginUser();
        localStorage.removeItem('rememberedUser');
        //如果当前页面在我的订单、个人中心页面，退出后回到首页
        if (router.currentRoute.value.path === "/person" || router.currentRoute.value.path === "/order") {
          router.push({
            path: "/",
            replace: true
          });
        }
      }
      if (command === "person") {
        router.push({
          path: "/person"
        });
      }
    };
    // 计算可见的路由并转换为菜单项格式
    const visibleRoutes = computed(() => {
      //过滤父路由
      const oldRoutes = routes.filter(item => {
        if (item.meta?.visible) {
          return false;
        }
        if (!checkAccess(loginUserStore.loginUser, item?.meta?.access)) {
          return false;
        }
        return true;
      });
      const convertToMenuItems = oldRoutes => {
        //再过滤一遍路由 主要还是还是针对子路由
        oldRoutes = oldRoutes.filter(item => {
          if (item.meta?.visible) {
            return false;
          }
          if (!checkAccess(loginUserStore.loginUser, item?.meta?.access)) {
            return false;
          }
          return true;
        });
        return oldRoutes.map(route => {
          const item = {
            key: route.path,
            label: route.name,
            icon: route.meta?.icon ? () => h(route.meta?.icon) : undefined,
            children: route.children ? convertToMenuItems(route.children) : undefined
          };
          return item;
        });
      };
      return convertToMenuItems(oldRoutes);
    });
    //路由跳转后，设置当前选中的菜单
    router.afterEach((to, from, failure) => {
      selectedKeys.value = [to.path];
    });
    const selectedKeys = ref(['/']);
    //获取当前用户信息
    const getLoginUser = async () => {
      const user = await loginUserStore.getLoginUser();
      if (user) {
        store.commit('updateUser', user);
      }
      //登录和注册后加载
      userLoaded.value = true;
    };
    onMounted(() => {
      getLoginUser();
      nextTick(() => {
        if (menuItemRef.value) {
          menuItemRef.value.dispatchEvent(new MouseEvent('mouseenter'));
        }
      });
      const rememberedUserValue = localStorage.getItem('rememberedUser');
      if (rememberedUserValue) {
        rememberMe.value = JSON.parse(rememberedUserValue);
      }
    });
    const doMenuClick = (item, key, keyPath) => {
      router.push({
        path: item.key
      });
    };
    // 添加新的响应式变量
    const loginModalVisible = ref(false);
    const loginLoading = ref(false);
    const rememberMe = ref(false);
    const loginType = ref('account');
    const loginForm = ref({
      username: '',
      email: '',
      password: ''
    });
    // 显示登录模态框
    const showLoginModal = () => {
      loginModalVisible.value = true;
    };
    const resetLoginForm = () => {
      loginForm.value = {
        username: '',
        email: '',
        password: ''
      };
    };
    // 处理登录逻辑
    const handleLogin = async values => {
      try {
        loginLoading.value = true;
        const loginData = {
          ...values,
          loginType: loginType.value
        };
        const res = await loginUserStore.login(loginData);
        if (res) {
          message.success('登录成功');
          loginModalVisible.value = false;
          //将记住我保存到浏览器
          localStorage.setItem('rememberedUser', JSON.stringify(rememberMe.value));
          resetLoginForm();
        } else {
          message.error("用户不存在/密码错误");
        }
      } catch (error) {
        message.error("登录失败!");
      } finally {
        loginLoading.value = false;
      }
    };
    // 注册相关的响应式变量
    const registerModalVisible = ref(false);
    const registerLoading = ref(false);
    const registerForm = ref({
      username: '',
      password: '',
      checkPassword: '',
      email: '',
      code: '',
      uuid: ''
    });
    const captchaUrl = ref('');
    // 添加邮箱验证状态
    const emailValidateStatus = ref(''); // 可能的值: 'success', 'error', ''
    const emailValidateMessage = ref('');
    // 显示注册模态框
    const showRegisterModal = () => {
      registerModalVisible.value = true;
      refreshCaptcha();
    };
    // 切换到登录模态框
    const switchToLogin = () => {
      registerModalVisible.value = false;
      forgotPasswordVisible.value = false;
      showLoginModal();
    };
    // 切换到注册模态框
    const switchToRegister = () => {
      registerLoading.value = false;
      showRegisterModal();
    };
    // 刷新验证码
    const refreshCaptcha = () => {
      // 这里需要调用后端接口获取验证码
      CaptchaControllerService.getCodeUsingGet().then(res => {
        captchaUrl.value = "data:image/gif;base64," + res.img;
        registerForm.value.uuid = res.uuid;
      });
    };
    // 验证两次密码是否一致
    const validatePassword = async (_rule, value) => {
      if (value && value !== registerForm.value.password) {
        throw new Error('两次输入的密码不一致');
      }
    };
    // 邮箱格式验证函数
    const validateEmail = async (_rule, value) => {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (!emailRegex.test(value)) {
        throw new Error('请输入正确的邮箱格式(用于找回密码)');
      }
      return true;
    };
    // 邮箱格式验证函数
    const validateEmailOther = async (_rule, value) => {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (!emailRegex.test(value)) {
        throw new Error('请输入正确的邮箱格式');
      }
      return true;
    };
    // 修改邮箱验证函数
    const validateEmailExists = async email => {
      try {
        const res = await XiaoniuFrontedControllerService.checkEmailExists(email);
        if (res.data.code != 200) {
          emailValidateStatus.value = 'error';
          emailValidateMessage.value = '该邮箱已被注册';
          return false;
        } else {
          emailValidateStatus.value = 'success';
          emailValidateMessage.value = '邮箱可以使用';
          return true;
        }
      } catch (error) {
        emailValidateStatus.value = 'error';
        emailValidateMessage.value = '邮箱验证失败，请重试';
        return false;
      }
    };
    // 修改邮箱输入框的失焦处理
    const handleEmailBlur = async () => {
      if (!registerForm.value.email) {
        emailValidateStatus.value = '';
        emailValidateMessage.value = '';
        return;
      }
      try {
        await validateEmail(null, registerForm.value.email);
        await validateEmailExists(registerForm.value.email);
      } catch (error) {
        emailValidateStatus.value = 'error';
        emailValidateMessage.value = error.message;
      }
    };
    // 清除邮箱验证状态
    const handleEmailFocus = () => {
      emailValidateStatus.value = '';
      emailValidateMessage.value = '';
    };
    // 处理注册逻辑
    const handleRegister = async () => {
      try {
        emailValidateStatus.value = 'error';
        registerLoading.value = true;
        // 这里调用注册接口
        let res = await SysRegisterControllerService.registerByFrontedUsingPost(registerForm.value);
        if (res.code === 200) {
          message.success("注册成功，请登录~");
          registerModalVisible.value = false;
          // 重置表单
          registerForm.value = {
            username: '',
            password: '',
            checkPassword: '',
            email: '',
            code: '',
            uuid: ''
          };
          // 自动显示登录框
          showLoginModal();
        } else {
          message.error(res.msg);
        }
      } finally {
        refreshCaptcha();
        registerLoading.value = false;
      }
    };
    //获取验证码信息
    // const getCaptcha = async () => {
    //   CaptchaControllerService.getCodeUsingGet().then((res: any) => {
    //     captchaUrl.value = res.data;
    //   });
    // };
    // 添加忘记密码相关的响应式变量
    const forgotPasswordVisible = ref(false);
    const forgotPasswordLoading = ref(false);
    const forgotPasswordForm = ref({
      email: '',
      code: '',
      newPassword: '',
      checkPassword: '',
      uuid: ''
    });
    const codeSending = ref(false);
    const countdown = ref(0);
    const timer = ref(null);
    // 显示忘记密码模态框
    const showForgotPassword = () => {
      loginModalVisible.value = false;
      forgotPasswordVisible.value = true;
    };
    // 处理发送验证码
    const handleSendCode = async () => {
      if (!forgotPasswordForm.value.email) {
        message.error('请先输入邮箱');
        return;
      }
      try {
        codeSending.value = true;
        // 调用发送验证码接口
        const res = await XiaoniuFrontedControllerService.sendCode(forgotPasswordForm.value.email);
        if (res) {
          message.success('验证码已发送到邮箱');
          countdown.value = 60;
          timer.value = setInterval(() => {
            countdown.value--;
            if (countdown.value <= 0) {
              clearInterval(timer.value);
              timer.value = null;
            }
          }, 1000);
        }
      } catch (error) {
        message.error('发送失败，请重试');
      } finally {
        codeSending.value = false;
      }
    };
    // 验证两次密码是否一致
    const validateResetPassword = async (_rule, value) => {
      if (value && value !== forgotPasswordForm.value.newPassword) {
        throw new Error('两次输入的密码不一致');
      }
    };
    // 处理重置密码
    const handleResetPassword = async () => {
      try {
        forgotPasswordLoading.value = true;
        const res = await XiaoniuFrontedControllerService.resetPassword(forgotPasswordForm.value);
        if (res.data.code === 200) {
          message.success('密码重置成功，请重新登录');
          forgotPasswordVisible.value = false;
          showLoginModal();
          // 重置表单
          forgotPasswordForm.value = {
            email: '',
            code: '',
            newPassword: '',
            checkPassword: '',
            uuid: ''
          };
        } else {
          message.error(res.data.msg);
        }
      } catch (error) {
        message.error('重置失败，请重试');
      } finally {
        forgotPasswordLoading.value = false;
      }
    };
    // 组件卸载时清除定时器
    onUnmounted(() => {
      if (timer.value) {
        clearInterval(timer.value);
      }
    });
    // 处理 Gitee 登录
    const handleGiteeLogin = async () => {
      try {
        const res = await GiteeLoginConrollerService.preLoginByGiteeUsingGetFronted();
        localStorage.setItem('user-uuid', res.uuid); // 现在 TypeScript 知道 `res` 是 `GiteeLoginResponse` 类型
        //保存之前的路由信息到浏览器之中
        window.localStorage.setItem('previousRoute', JSON.stringify({
          path: router.currentRoute.value.path,
          query: router.currentRoute.value.query
        }));
        window.location = res.authorizeUrl;
      } catch (error) {
        console.error('登录错误:', error);
      }
    };
    // 处理 微信 登录
    const handleWeChatLogin = async () => {
      message.warning('暂未开通~');
    };
    return (_ctx, _cache) => {
      const _component_a_col = _resolveComponent("a-col");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_a_space = _resolveComponent("a-space");
      const _component_el_button = _resolveComponent("el-button");
      const _component_a_row = _resolveComponent("a-row");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_input_password = _resolveComponent("a-input-password");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_a_row, {
        id: "globalHeader",
        wrap: false
      }, {
        default: _withCtx(() => [_createVNode(_component_a_col, {
          flex: "130px"
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_a_col, {
          flex: "auto"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_menu, {
            pro: "",
            selectedKeys: selectedKeys.value,
            "onUpdate:selectedKeys": _cache[0] || (_cache[0] = $event => selectedKeys.value = $event),
            mode: "horizontal",
            items: visibleRoutes.value,
            onClick: doMenuClick
          }, null, 8, ["selectedKeys", "items"])]),
          _: 1
        }), _createVNode(_component_a_col, {
          flex: "130px"
        }, {
          default: _withCtx(() => [isLogin.value ? (_openBlock(), _createBlock(_component_a_space, {
            key: 0
          }, {
            default: _withCtx(() => [_createVNode(_component_el_dropdown, {
              class: "avatar-container",
              onCommand: handleCommand
            }, {
              dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                  command: "person"
                }, {
                  default: _withCtx(() => [_createTextVNode("个人中心")]),
                  _: 1
                }), _createVNode(_component_el_dropdown_item, {
                  command: "logout"
                }, {
                  default: _withCtx(() => [_createTextVNode("退出登录")]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
                src: _unref(loginUserStore).loginUser?.avatar === '' ? 'http://ocr.nbdj.cc/test/xiaoniu-logo.png' : _unref(loginUserStore).loginUser.avatar,
                class: "user-avatar"
              }, null, 8, _hoisted_3), _createVNode(_component_el_icon, {
                class: "el-icon-caret-bottom"
              }, {
                default: _withCtx(() => [_createVNode(_unref(ArrowDown))]),
                _: 1
              })])]),
              _: 1
            }), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_tooltip, {
              content: _unref(loginUserStore).loginUser?.nickName ?? ''
            }, {
              default: _withCtx(() => [_createElementVNode("span", _hoisted_5, _toDisplayString(truncatedUserName.value), 1)]),
              _: 1
            }, 8, ["content"])])]),
            _: 1
          })) : !isLogin.value && userLoaded.value ? (_openBlock(), _createBlock(_component_a_space, {
            key: 1
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              style: {
                "margin-right": "10px"
              },
              onClick: showLoginModal
            }, {
              default: _withCtx(() => [_createTextVNode("登录")]),
              _: 1
            }), _createVNode(_component_el_button, {
              type: "primary",
              onClick: showRegisterModal
            }, {
              default: _withCtx(() => [_createTextVNode("注册")]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_a_modal, {
        open: loginModalVisible.value,
        "onUpdate:open": _cache[7] || (_cache[7] = $event => loginModalVisible.value = $event),
        title: null,
        footer: null,
        width: "400px",
        centered: "",
        maskClosable: false,
        class: "login-modal",
        destroyOnClose: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("span", {
          class: _normalizeClass(['switch-item', {
            active: loginType.value === 'account'
          }]),
          onClick: _cache[1] || (_cache[1] = $event => loginType.value = 'account')
        }, " 账号登录 ", 2), _createElementVNode("span", {
          class: _normalizeClass(['switch-item', {
            active: loginType.value === 'email'
          }]),
          onClick: _cache[2] || (_cache[2] = $event => loginType.value = 'email')
        }, " 邮箱登录 ", 2)]), _createVNode(_component_a_form, {
          model: loginForm.value,
          onFinish: handleLogin,
          class: "login-form"
        }, {
          default: _withCtx(() => [loginType.value === 'account' ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 0,
            name: "username",
            rules: [{
              required: true,
              message: '请输入用户名'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: loginForm.value.username,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => loginForm.value.username = $event),
              size: "large",
              placeholder: "用户名",
              autoComplete: "new-username"
            }, {
              prefix: _withCtx(() => [_createVNode(_unref(UserOutlined), {
                class: "site-form-item-icon"
              })]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_a_form_item, {
            key: 1,
            name: "email",
            rules: [{
              validator: validateEmailOther
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: loginForm.value.email,
              "onUpdate:value": _cache[4] || (_cache[4] = $event => loginForm.value.email = $event),
              size: "large",
              placeholder: "邮箱"
            }, {
              prefix: _withCtx(() => [_createVNode(_unref(MailOutlined), {
                class: "site-form-item-icon"
              })]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          }, 8, ["rules"])), _createVNode(_component_a_form_item, {
            name: "password",
            rules: [{
              required: true,
              message: '请输入密码'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input_password, {
              value: loginForm.value.password,
              "onUpdate:value": _cache[5] || (_cache[5] = $event => loginForm.value.password = $event),
              size: "large",
              placeholder: "密码",
              autoComplete: "new-password"
            }, {
              prefix: _withCtx(() => [_createVNode(_unref(LockOutlined), {
                class: "site-form-item-icon"
              })]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          }), _createElementVNode("div", _hoisted_9, [_createVNode(_component_a_checkbox, {
            checked: rememberMe.value,
            "onUpdate:checked": _cache[6] || (_cache[6] = $event => rememberMe.value = $event),
            class: "remember-checkbox"
          }, {
            default: _withCtx(() => [_createTextVNode(" 记住我 ")]),
            _: 1
          }, 8, ["checked"]), _createElementVNode("a", {
            class: "forgot-link",
            onClick: showForgotPassword
          }, "忘记密码?")]), _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit",
              class: "login-form-button",
              loading: loginLoading.value,
              size: "large"
            }, {
              default: _withCtx(() => [_createTextVNode(" 登录 ")]),
              _: 1
            }, 8, ["loading"])]),
            _: 1
          }), _hoisted_10, _createElementVNode("div", {
            class: "third-party-login"
          }, [_createElementVNode("div", {
            class: "login-icon gitee",
            onClick: handleGiteeLogin
          }, _hoisted_13), _createElementVNode("div", {
            class: "login-icon gitee",
            onClick: handleWeChatLogin
          }, _hoisted_16)]), _createElementVNode("div", {
            class: "register-link"
          }, [_createTextVNode(" 还没有账号？"), _createElementVNode("a", {
            onClick: switchToRegister
          }, "立即注册")])]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      }, 8, ["open"]), _createVNode(_component_a_modal, {
        open: registerModalVisible.value,
        "onUpdate:open": _cache[13] || (_cache[13] = $event => registerModalVisible.value = $event),
        title: null,
        footer: null,
        width: "400px",
        centered: "",
        maskClosable: false,
        class: "login-modal",
        destroyOnClose: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_hoisted_18, _createVNode(_component_a_form, {
          model: registerForm.value,
          onFinish: handleRegister,
          class: "login-form"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            name: "username",
            rules: [{
              required: true,
              message: '请输入用户名'
            }, {
              min: 2,
              message: '用户名至少2个字符'
            }, {
              max: 20,
              message: '用户名最多20个字符'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: registerForm.value.username,
              "onUpdate:value": _cache[8] || (_cache[8] = $event => registerForm.value.username = $event),
              size: "large",
              placeholder: "请设置用户名",
              autoComplete: "new-username"
            }, {
              prefix: _withCtx(() => [_createVNode(_unref(UserOutlined), {
                class: "site-form-item-icon"
              })]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            name: "password",
            rules: [{
              required: true,
              message: '请输入密码'
            }, {
              min: 5,
              message: '密码至少5个字符'
            }, {
              max: 20,
              message: '密码至多20个字符'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input_password, {
              value: registerForm.value.password,
              "onUpdate:value": _cache[9] || (_cache[9] = $event => registerForm.value.password = $event),
              size: "large",
              placeholder: "请设置密码",
              autoComplete: "new-password"
            }, {
              prefix: _withCtx(() => [_createVNode(_unref(LockOutlined), {
                class: "site-form-item-icon"
              })]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            name: "checkPassword",
            rules: [{
              required: true,
              message: '请确认密码'
            }, {
              validator: validatePassword
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input_password, {
              value: registerForm.value.checkPassword,
              "onUpdate:value": _cache[10] || (_cache[10] = $event => registerForm.value.checkPassword = $event),
              size: "large",
              placeholder: "请确认密码"
            }, {
              prefix: _withCtx(() => [_createVNode(_unref(LockOutlined), {
                class: "site-form-item-icon"
              })]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_a_form_item, {
            name: "email",
            rules: [
              // { validator: validateEmailOther }
            ],
            "validate-status": emailValidateStatus.value
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: registerForm.value.email,
              "onUpdate:value": _cache[11] || (_cache[11] = $event => registerForm.value.email = $event),
              size: "large",
              placeholder: "请输入邮箱(用于找回密码)",
              onBlur: handleEmailBlur,
              onFocus: handleEmailFocus
            }, {
              prefix: _withCtx(() => [_createVNode(_unref(MailOutlined), {
                class: "site-form-item-icon"
              })]),
              _: 1
            }, 8, ["value"]), emailValidateMessage.value ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['email-validate-message', emailValidateStatus.value])
            }, [emailValidateStatus.value === 'success' ? (_openBlock(), _createBlock(_unref(CheckCircleFilled), {
              key: 0,
              class: "icon"
            })) : _createCommentVNode("", true), emailValidateStatus.value === 'error' ? (_openBlock(), _createBlock(_unref(CloseCircleFilled), {
              key: 1,
              class: "icon"
            })) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(emailValidateMessage.value), 1)], 2)) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["validate-status"]), _createVNode(_component_a_form_item, {
            name: "code",
            rules: [{
              required: true,
              message: '请输入验证码'
            }]
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createVNode(_component_a_input, {
              value: registerForm.value.code,
              "onUpdate:value": _cache[12] || (_cache[12] = $event => registerForm.value.code = $event),
              size: "large",
              placeholder: "请输入验证码"
            }, {
              prefix: _withCtx(() => [_createVNode(_unref(SafetyCertificateOutlined), {
                class: "site-form-item-icon"
              })]),
              _: 1
            }, 8, ["value"]), _createElementVNode("div", {
              class: "captcha-image",
              onClick: refreshCaptcha
            }, [_createElementVNode("img", {
              src: captchaUrl.value,
              alt: "验证码"
            }, null, 8, _hoisted_20), _hoisted_21])])]),
            _: 1
          }), _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit",
              class: "login-form-button",
              loading: registerLoading.value,
              size: "large"
            }, {
              default: _withCtx(() => [_createTextVNode(" 注册 ")]),
              _: 1
            }, 8, ["loading"])]),
            _: 1
          }), _hoisted_22, _createVNode(_component_a_button, {
            class: "register-button",
            size: "large",
            onClick: switchToLogin
          }, {
            default: _withCtx(() => [_createTextVNode(" 立即登录 ")]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      }, 8, ["open"]), _createVNode(_component_a_modal, {
        open: forgotPasswordVisible.value,
        "onUpdate:open": _cache[18] || (_cache[18] = $event => forgotPasswordVisible.value = $event),
        title: null,
        footer: null,
        width: "400px",
        centered: "",
        maskClosable: false,
        class: "login-modal",
        destroyOnClose: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_hoisted_24, _createVNode(_component_a_form, {
          model: forgotPasswordForm.value,
          onFinish: handleResetPassword,
          class: "login-form"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            name: "email",
            rules: [{
              validator: validateEmail
            }]
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createVNode(_component_a_input, {
              value: forgotPasswordForm.value.email,
              "onUpdate:value": _cache[14] || (_cache[14] = $event => forgotPasswordForm.value.email = $event),
              size: "large",
              placeholder: "请输入注册时的邮箱",
              autoComplete: "new-email"
            }, {
              prefix: _withCtx(() => [_createVNode(_unref(MailOutlined), {
                class: "site-form-item-icon"
              })]),
              _: 1
            }, 8, ["value"]), _createVNode(_component_a_button, {
              type: "primary",
              loading: codeSending.value,
              disabled: countdown.value > 0,
              onClick: handleSendCode,
              class: "send-code-button"
            }, {
              default: _withCtx(() => [countdown.value <= 0 ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_createTextVNode(" 发送验证码 ")], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("span", _hoisted_27, _toDisplayString(countdown.value), 1), _hoisted_28]))]),
              _: 1
            }, 8, ["loading", "disabled"])])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_a_form_item, {
            name: "code",
            rules: [{
              required: true,
              message: '请输入验证码'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: forgotPasswordForm.value.code,
              "onUpdate:value": _cache[15] || (_cache[15] = $event => forgotPasswordForm.value.code = $event),
              size: "large",
              placeholder: "请输入邮箱验证码"
            }, {
              prefix: _withCtx(() => [_createVNode(_unref(SafetyCertificateOutlined), {
                class: "site-form-item-icon"
              })]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            name: "newPassword",
            rules: [{
              required: true,
              message: '请输入新密码'
            }, {
              min: 6,
              message: '密码至少6个字符'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input_password, {
              value: forgotPasswordForm.value.newPassword,
              "onUpdate:value": _cache[16] || (_cache[16] = $event => forgotPasswordForm.value.newPassword = $event),
              size: "large",
              placeholder: "请设置新密码",
              autoComplete: "new-password"
            }, {
              prefix: _withCtx(() => [_createVNode(_unref(LockOutlined), {
                class: "site-form-item-icon"
              })]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            name: "checkPassword",
            rules: [{
              required: true,
              message: '请确认密码'
            }, {
              validator: validateResetPassword
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input_password, {
              value: forgotPasswordForm.value.checkPassword,
              "onUpdate:value": _cache[17] || (_cache[17] = $event => forgotPasswordForm.value.checkPassword = $event),
              size: "large",
              placeholder: "请确认新密码",
              autoComplete: "new-checkPassword"
            }, {
              prefix: _withCtx(() => [_createVNode(_unref(LockOutlined), {
                class: "site-form-item-icon"
              })]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit",
              class: "login-form-button",
              loading: forgotPasswordLoading.value,
              size: "large"
            }, {
              default: _withCtx(() => [_createTextVNode(" 重置密码 ")]),
              _: 1
            }, 8, ["loading"])]),
            _: 1
          }), _hoisted_29, _createVNode(_component_a_button, {
            class: "register-button",
            size: "large",
            onClick: switchToLogin
          }, {
            default: _withCtx(() => [_createTextVNode(" 返回登录 ")]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      }, 8, ["open"])]);
    };
  }
});